import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-intro" }
const _hoisted_2 = { class: "text-gray-600 body-font" }
const _hoisted_3 = { class: "container mx-auto flex px-5 py-24 md:flex-row flex-col items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900" }, " Know the meaning of your name ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "mb-8 leading-relaxed" }, " Lorem ipsum, dolor sit amet consectetur adipisicing elit. Culpa repudiandae assumenda sit, laboriosam at dolore? Rem, natus accusamus quos, excepturi similique commodi, doloribus minima quod consectetur illo obcaecati aperiam libero! ", -1)
const _hoisted_6 = { class: "flex w-full md:justify-start justify-center items-end" }
const _hoisted_7 = { class: "relative mr-4 md:w-full lg:w-full xl:w-1/2 w-2/4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "hero-field",
  class: "leading-7 text-sm text-gray-600"
}, " Enter name ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary"
}, "Go", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm mt-2 text-gray-500 mb-8 w-full" }, " Lorem ipsum dolor, sit amet consectetur adipisicing elit. ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "lg:max-w-lg lg:w-full md:w-1/2 w-5/6" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "object-cover object-center rounded",
    alt: "hero",
    src: "https://dummyimage.com/720x600"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
          class: "lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center"
        }, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "hero-field",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputText) = $event)),
                name: "hero-field",
                class: "input-control",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.inputText]
              ])
            ]),
            _hoisted_9
          ]),
          _hoisted_10
        ], 32),
        _hoisted_11
      ])
    ])
  ]))
}